import { BaseType } from '../../base/base-type';
import { Deserializable } from '../../protocols/deserializable';
import { AnnuityGuaranteePeriodTypeId, AnnuityGuaranteePeriodValue } from '../enum/annuity-guarantee-period-type';
import { AnnuitySurvivorBenefitTypeId, AnnuitySurvivorBenefitValue } from '../enum/annuity-survivor-benefit-type';

export class GuaranteePeriod extends BaseType {
  public declare id: AnnuityGuaranteePeriodTypeId;
  public value!: AnnuityGuaranteePeriodValue;
}

export class SurvivorBenefit extends BaseType {
  public declare id: AnnuitySurvivorBenefitTypeId;
  public value!: AnnuitySurvivorBenefitValue;
}

export class AnnuityCalculation implements Deserializable {
  public guaranteePeriod!: GuaranteePeriod;
  public memberAmount!: number;
  // Only present on joint life & survivor calculations
  public jointLifeAmount?: number;

  onDeserialize(): void {
    this.guaranteePeriod = window?.injector?.Deserialize?.instanceOf(GuaranteePeriod, this.guaranteePeriod);
  }
}

export class JointLifeAndSurvivorBenefit implements Deserializable {
  public survivorBenefit!: SurvivorBenefit;
  public annuityCalculations!: AnnuityCalculation[];

  onDeserialize(): void {
    this.survivorBenefit = window?.injector?.Deserialize?.instanceOf(SurvivorBenefit, this.survivorBenefit);
    this.annuityCalculations = window?.injector?.Deserialize?.arrayOf(AnnuityCalculation, this.annuityCalculations);
  }
}

export abstract class AnnuityCalculationResponse implements Deserializable {
  public retirementDate!: string;
  public equity!: number;
  public memberBirthDate!: string;
  public memberAge!: number;
  public memberDaysUntilBirthDate!: number;

  abstract onDeserialize(): void;
}

export class LifeOnlyAnnuityCalculationResponse extends AnnuityCalculationResponse {
  public annuityCalculations!: AnnuityCalculation[];

  override onDeserialize(): void {
    this.annuityCalculations = window?.injector?.Deserialize?.arrayOf(AnnuityCalculation, this.annuityCalculations);
  }
}

export class JointLifeAnnuityCalculationResponse extends AnnuityCalculationResponse {
  public spousalBirthDate!: string;
  public spousalAge!: number;
  public spousalDaysUntilBirthDate!: number;
  public jointLifeAndSurvivorBenefits!: JointLifeAndSurvivorBenefit[];

  override onDeserialize(): void {
    this.jointLifeAndSurvivorBenefits = window?.injector?.Deserialize?.arrayOf(
      JointLifeAndSurvivorBenefit,
      this.jointLifeAndSurvivorBenefits
    );
  }
}
